import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import LoadingAnimation from './Routing';
import {  HelmetProvider } from "@vuer-ai/react-helmet-async";
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import TrackerProvider from "./TrackerProvider";
// 👉 GLOBALNA FLAGA (exportowana)
export let IS_DEMO = false;
export let name = undefined;
export let displayname = "";

function App() {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const ref = doc(db, 'config', 'app');
        const snap = await getDoc(ref);

        if (snap.exists()) {
          IS_DEMO = snap.data().demo === true;
          name = snap.data().name 
          displayname = snap.data().displayname 
        }
      } catch (e) {
        console.error('Failed to load app config', e);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  if (loading) return null; // albo loader

  return (
    <Router>
      <HelmetProvider>
      <TrackerProvider>
        <LoadingAnimation />
      </TrackerProvider>
      </HelmetProvider>
    </Router>
  );
}

export default App;
